import inherits from 'inherits';

import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';

import {
  getBusinessObject,
  is
} from '../../../base/BaseServices';

import {
  computeChildrenBBox
} from 'diagram-js/lib/features/resize/ResizeUtil';


var LOW_PRIORITY = 500;


export default function ElementCollapseAction(
  eventBus, elementFactory, modeling, resize
) {
  CommandInterceptor.call(this, eventBus);

  function hideEmptyLabels(children) {
    children.forEach(function(child) {
      if (child.type === 'label' && !child.businessObject.name) {
        child.hidden = true;
      }
    });
  }

  function expandedBounds(shape, defaultSize) {
    var children = shape.children;
    var newBounds = defaultSize;
    var visibleElements;
    var visibleBBox;

    visibleElements = filterVisible(children).concat([shape]);

    visibleBBox = computeChildrenBBox(visibleElements);

    if (visibleBBox) {
      newBounds.width = Math.max(visibleBBox.width, newBounds.width);
      newBounds.height = Math.max(visibleBBox.height, newBounds.height);

      newBounds.x = visibleBBox.x + (visibleBBox.width - newBounds.width) / 2;
      newBounds.y = visibleBBox.y + (visibleBBox.height - newBounds.height) / 2;
    } else {
      newBounds.x = shape.x + (shape.width - newBounds.width) / 2;
      newBounds.y = shape.y + (shape.height - newBounds.height) / 2;
    }

    return newBounds;
  }

  function collapsedBounds(shape, defaultSize) {
    return {
      x: shape.x + (shape.width - defaultSize.width) / 2,
      y: shape.y + (shape.height - defaultSize.height) / 2,
      width: defaultSize.width,
      height: defaultSize.height
    };
  }

  function toggleCollapse(context, collapsed) {
    var shape = context.shape;

    if (!is(shape, 'bpmn:SubProcess')) {
      return;
    }

    hideEmptyLabels(shape.children);
    getBusinessObject(shape).di.isExpanded = !collapsed;
  }

  function resizeShapeAfterToggle(context, defaultSize) {
    var shape = context.shape;
    var newBounds;

    if (shape.collapsed) {
      newBounds = collapsedBounds(shape, defaultSize);
    } else {
      newBounds = expandedBounds(shape, defaultSize);
    }

    modeling.resizeShape(shape, newBounds, null, {
      autoResize: shape.collapsed ? false : 'nwse'
    });
  }

  this.executed([ 'shape.toggleCollapse' ], LOW_PRIORITY, function(e) {
    toggleCollapse(e.context, false);
  });

  this.reverted([ 'shape.toggleCollapse' ], LOW_PRIORITY, function(e) {
    toggleCollapse(e.context, true);
  });

  this.postExecuted([ 'shape.toggleCollapse' ], LOW_PRIORITY, function(e) {
    var shape = e.context.shape;
    var defaultSize = elementFactory._getDefaultSize(shape);

    resizeShapeAfterToggle(e.context, defaultSize);
  });
}


inherits(ElementCollapseAction, CommandInterceptor);

ElementCollapseAction.$inject = [
  'eventBus',
  'elementFactory',
  'modeling'
];


// helpers //////////////////////

function filterVisible(elements) {
  return elements.filter(e => !e.hidden);
}
